/* ==========================================================================
   LP product annotation —— 图片热点行为
   桌面：点圆点拦下跳转、展开卡片，再点卡片里的链接才去商品页
   手机：不拦截，<a> 原生直接跳商品页
   当前处于哪种模式由 CSS 的 --hotspot-mode 决定 —— 断点只在 CSS 里定义一次，
   这里不再判断窗口宽度，避免两处 749px 各自漂移
   ========================================================================== */

class LpProductHotspot extends HTMLElement {
  constructor() {
    super();
    this.trigger = null;
    this.card = null;
    this.isOpen = false;

    this.onTriggerClick = this.onTriggerClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if (!this.trigger) return;

    this.trigger.removeEventListener('click', this.onTriggerClick);
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeydown);
  }

  init() {
    this.trigger = this.querySelector('.lpef__hotspot-trigger');
    this.card = this.querySelector('.lpef__hotspot-card');
    if (!this.trigger || !this.card) return;

    this.trigger.addEventListener('click', this.onTriggerClick);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeydown);
  }

  /* 读 CSS 声明好的模式，而不是在 JS 里再判断一次窗口宽度 */
  get mode() {
    const value = getComputedStyle(this).getPropertyValue('--hotspot-mode');
    return value.trim() || 'card';
  }

  onTriggerClick(event) {
    // 手机端放行，让 <a> 自己跳商品页
    if (this.mode !== 'card') return;

    event.preventDefault();
    this.setOpen(!this.isOpen);
  }

  onDocumentClick(event) {
    if (!this.isOpen || this.contains(event.target)) return;
    this.setOpen(false);
  }

  onKeydown(event) {
    if (event.key !== 'Escape' || !this.isOpen) return;

    this.setOpen(false);
    this.trigger.focus();
  }

  setOpen(open) {
    this.isOpen = open;
    this.card.hidden = !open;
    this.trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
}

if (!customElements.get('lp-product-hotspot')) {
  customElements.define('lp-product-hotspot', LpProductHotspot);
}
